import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check } from 'lucide-react';
import './Products.css';
import emailValidifyProduct from '../../assets/images/products/email-validify-banner.jpg';
import enhanzioProduct from '../../assets/images/products/enhanzio-banner.png';

const Products: React.FC = () => {
  return (
    <section className="section products-section" id="products">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Our products</h2>
          <p className="section-subtitle">
            Email Validify and Enhanzio are our live products—built for trust, quality, and real-world
            performance.
          </p>

          <div className="products-showcase">
            <div className="products-split-row">
              <motion.div
                className="products-split-media"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                <img
                  src={emailValidifyProduct}
                  alt="Email Validify — verify any email with a complete email checker"
                />
              </motion.div>
              <motion.div
                className="products-split-body"
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                <p className="products-split-eyebrow">Email Validify</p>
                <h3 className="products-split-headline">
                  <span className="products-split-headline-accent">Verify any email address</span>
                  <span className="products-split-headline-rest">
                    {' '}
                    with the most complete email checker
                  </span>
                </h3>
                <ul className="products-split-benefits">
                  <li>
                    <Check className="products-split-check" aria-hidden />
                    100 free validation credits every month
                  </li>
                  <li>
                    <Check className="products-split-check" aria-hidden />
                    Cheapest email validation solution
                  </li>
                  <li>
                    <Check className="products-split-check" aria-hidden />
                    No credit expiry—use anytime
                  </li>
                  <li>
                    <Check className="products-split-check" aria-hidden />
                    No credit deduction for unverified emails
                  </li>
                  <li>
                    <Check className="products-split-check" aria-hidden />
                    Catch-all emails? No credits used
                  </li>
                </ul>
                <a
                  className="products-split-cta products-split-cta--secondary"
                  href="https://emailvalidify.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span>Try for free</span>
                  <ArrowRight className="products-split-cta-arrow" aria-hidden strokeWidth={2.5} />
                </a>
              </motion.div>
            </div>

            <div className="products-split-row products-split-row--reverse">
              <motion.div
                className="products-split-body"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                <p className="products-split-eyebrow">Enhanzio</p>
                <h3 className="products-split-headline">
                  <span className="products-split-headline-accent">Restore and sharpen photos</span>
                  <span className="products-split-headline-rest">
                    {' '}
                    with AI—in seconds, in premium quality
                  </span>
                </h3>
                <p className="products-split-subtitle">
                  Professional AI-powered photo enhancement for sharper, clearer, and higher-quality
                  images.
                </p>
                <ul className="products-split-benefits">
                  <li>
                    <Check className="products-split-check" aria-hidden />
                    AI Photo Enhancer for old, blurry, or compressed images
                  </li>
                  <li>
                    <Check className="products-split-check" aria-hidden />
                    AI Image Upscaler for clearer detail and higher resolution
                  </li>
                  <li>
                    <Check className="products-split-check" aria-hidden />
                    AI Photo Restoration ready to save, print, or share
                  </li>
                  <li>
                    <Check className="products-split-check" aria-hidden />
                    Simple flow: upload, enhance, download
                  </li>
                </ul>
                <a
                  className="products-split-cta products-split-cta--secondary"
                  href="http://enhanzio.xenvota.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span>Visit Enhanzio</span>
                  <ArrowRight className="products-split-cta-arrow" aria-hidden strokeWidth={2.5} />
                </a>
              </motion.div>
              <motion.div
                className="products-split-media"
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                <img src={enhanzioProduct} alt="Enhanzio – AI Photo Enhancer" />
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Products;
